import React from 'react';
import { Input, Button, CheckboxTable, Select, PaperClip, DatePicker, Checkbox } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, Colors, Api } from 'utils';
import moment from 'moment';
import { RevisionService, MembershipService } from 'services';
import { connect } from 'react-redux';
import {
  UploadIcon,
  CloseIcon,
  BackIcon,
  CheckWhiteIcon,
  CopyIcon,
  UserCircleIcon,
  ModeratorsIcon,
} from 'assets/icons';
import { StripeImage } from 'assets/img';
import { StepsContainer } from '../memberships/add-membership';
import axios from 'axios';

interface Props extends RootState {
  onClose?: any;
  item?: any;
  // DEV-LT-35 (Feature 2): plan_user viene de RevisionService.get() (ya cargado
  // en revision.tsx#load()). null/undefined = el cliente nunca tuvo membresia;
  // objeto = tiene/tuvo membresia, pero el servicio de Revision no esta incluido
  // (por eso igual cae en ACCESS_DENIED). Mismo criterio que el movil.
  // Fix TS2430: no puede ser opcional (?) porque RootState ya declara plan_user
  // como requerido -- una interfaz que extiende otra no puede aflojar una
  // propiedad heredada a opcional. El valor puede seguir siendo null/undefined
  // en runtime; esto solo afecta la forma del tipo, no el chequeo en tiempo real.
  plan_user: any;
  membership_status: number;
}
const STEPS = {
  TYPE: 0,
  AREA: 1,
  DOCUMENT: 2,
  ORDER: 3,
  PAYMENT: 4,
};

const to2 = (n: number) => Math.round(n * 100) / 100;

class ModalCreatePayment extends React.Component<Props> {
  formRef = React.createRef<HTMLDivElement>();

  state = {
    form: {
      area_id: '',
      person_type_id: '',
      file: '',
      document_id: '',
      search: '',
      payment_method_id: '',
      expiration_month: '',
      expiration_year: '',
      number: '',
      cvv: '',
      bank_id: '',
      phone: '',
      phonecode_id: '',
      date: '',
      reference: '',
      sypago_bank_code: '',
      sypago_phone: '',
      sypago_phonecode: '',
      sypago_document_type: '',
      sypago_document: '',
      sypago_otp: '',
      sypago_name: '',
      is_checked: false,
      // Nuevo: 'internal' | 'external', elegido en STEPS.TYPE -- mismo criterio
      // que modal-create.tsx.
      lawyer_type: '' as '' | 'internal' | 'both',
    },
    areas: [],
    documents: [],
    // Mapa document_id → price (ServiceDocumentPrice) para consultar el fee
    priceMap: new Map<number, any>(),
    person_types: [],
    step: STEPS.TYPE,
    months: [],
    years: [],
    banks: [],
    bank_data: null,
    iva: 0,
    conversion: 0,
    payment_methods: [],
    sypago_banks: [],
    phonecodes: [],
    document_types: [],
    otp_send: false,
    service_price: 0,
    visible_fee_notice: false,
    fee_notice_reason: null as 'no_membership' | 'no_marketplace' | 'no_uses' | null,
  };

  async componentDidMount() {
    // load() ya no se llama acá -- depende de lawyer_type, que se conoce recién
    // al elegir en STEPS.TYPE (ver selectType()). loadData() sí es independiente
    // del tipo de abogado (bancos/pasarelas), así que se mantiene aquí.
    this.loadData();

    let months = [];
    let years = [];

    for (let i = 1; i <= 12; i++) {
      months.push({
        value: moment(i, 'M').format('MM'),
        name: moment(i, 'M').format('MM'),
      });
    }

    for (let i = 0; i < 10; i++) {
      years.push({
        value: moment().add(i, 'years').format('YYYY'),
        name: moment().add(i, 'years').format('YYYY'),
      });
    }

    await this.setState({ months, years });
  }

  loadData = async () => {
    const res: any = await MembershipService.getBanks({ withoutLoading: true });
    this.setState({
      banks: res.banks || [],
      bank_data: res.bank_data,
      sypago_banks: res.sypago_banks || [],
      document_types: res.document_types || [],
      phonecodes: res.phonecodes || [],
      form: {
        ...this.state.form,
        sypago_document_type: res.document_types.length > 0 ? res.document_types[0].name : '',
        sypago_phonecode: res.phonecodes.length > 0 ? res.phonecodes[0].name : '',
        phonecode_id: res.phonecodes.length > 0 ? res.phonecodes[0].id : '',
      },
    });
  };

  load = async (lawyer_type: 'internal' | 'both') => {
    const revRes: any = await RevisionService.getAreas({
      user_id: this.props.user?.id,
      lawyer_type,
      withoutLoading: true,
    });

    // Construir mapa document_id → price a partir de los datos de revRes,
    // que incluye ServiceDocumentPrice (fee de plataforma) por documento.
    const priceMap = new Map<number, any>();
    for (const area of revRes.areas || []) {
      for (const doc of area.documents || []) {
        priceMap.set(doc.id, doc.price);
      }
    }

    const personTypes = revRes.person_types || [];
    this.setState({
      areas: revRes.areas || [],
      priceMap,
      person_types: personTypes,
      iva: revRes.iva?.value || 0,
      payment_methods: revRes.payment_methods || [],
      conversion: revRes.conversion?.amount || 0,
      service_price: revRes.service_price || 0,
      form: {
        ...this.state.form,
        person_type_id: personTypes.length > 0 ? personTypes[0].id : '',
      },
    });
  };

  selectType = (lawyer_type: 'internal' | 'both') => {
    this.setState({ visible_fee_notice: false, fee_notice_reason: null });

    // DESACTIVADO temporalmente: aviso de fee de plataforma para revisión
    // documental con abogados externos (directorio). El servicio ahora es
    // accesible sin cobro de fee para cualquier usuario, así que este banner
    // ya no se muestra al elegir "Abogado del directorio". No afecta el aviso
    // de "Abogado Law center" (compra de uso adicional), que sigue intacto.
    // if (lawyer_type === 'both') {
    //   this.setState({
    //     visible_fee_notice: true,
    //     fee_notice_reason: this.props.plan_user ? 'no_marketplace' : 'no_membership',
    //   });
    // }

    if (lawyer_type === 'internal') {
      this.setState({
        visible_fee_notice: true,
        fee_notice_reason: this.props.plan_user ? 'no_uses' : 'no_membership',
      });
    }

    this.setState({ form: { ...this.state.form, lawyer_type }, step: STEPS.AREA }, () =>
      this.load(lawyer_type),
    );
  };

  loadDocuments = async (area_id: any) => {
    const res: any = await RevisionService.getDocumentsByArea({
      user_id: this.props.user?.id,
      area_id: Number(area_id),
      lawyer_type: this.state.form.lawyer_type,
      withoutLoading: true,
    });
    this.setState({ documents: res.documents || [] });
  };

  change = (e: any, callback = () => {}, restart_otp = true) => {
    this.setState(
      {
        form: { ...this.state.form, [e.target.name]: e.target.value },
        otp_send: !restart_otp,
      },
      callback,
    );
  };

  selectPaymentMethod = (id: any) => {
    this.setState({ form: { ...this.state.form, payment_method_id: id } }, () => {
      setTimeout(() => {
        this.formRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 50);
    });
  };

  getTotal = () => {
    const isInternal = this.state.form.lawyer_type === 'internal';
    const priceMap: any = this.state.priceMap;
    const documentPrice = priceMap.get(Number(this.state.form.document_id));
    const subtotal = isInternal
      ? Number(this.state.service_price || 0)
      : Number(documentPrice?.fee || 0);
    const iva_total = subtotal * (Number(this.state.iva) / 100);
    const total_factura = subtotal + iva_total;
    const isStripe =
      this.state.form.payment_method_id?.toString() === Constants.PAYMENT_METHODS.STRIPE.toString();
    const igtf_total = isStripe ? total_factura * (Constants.TAXES.IGTF / 100) : 0;
    const total = total_factura + igtf_total;
    return {
      subtotal: to2(subtotal),
      iva_total: to2(iva_total),
      total_factura: to2(total_factura),
      igtf_total: to2(igtf_total),
      total: to2(total),
    };
  };

  submit = async () => {
    const { bank_id, phone, date, phonecode_id, is_checked } = this.state.form;
    const { subtotal, iva_total, total_factura, igtf_total, total } = this.getTotal();
    const isInternal = this.state.form.lawyer_type === 'internal';
    const fiscalOverrides = {
      __subtotal: subtotal,
      __iva_total: iva_total,
      __igtf_total: igtf_total,
      __total: total,
    };

    if (!is_checked) {
      Globals.showError('Por favor, declare que el pago proviene de manera lícita');
      return;
    }

    switch (this.state.form.payment_method_id.toString()) {
      case Constants.PAYMENT_METHODS.PAYMENT_MOBILE.toString(): {
        if (!bank_id) {
          Globals.showError('Por favor, ingrese el banco de origen');
          return;
        }
        if (!phonecode_id) {
          Globals.showError('Por favor, ingrese código del teléfono');
          return;
        }
        if (!phone) {
          Globals.showError('Por favor, ingrese el teléfono');
          return;
        }
        if (!date) {
          Globals.showError('Por favor, ingrese la fecha');
          return;
        }
        try {
          const formattedDate =
            this.state.form.date && moment(this.state.form.date, 'DD-MM-YYYY').format('YYYY-MM-DD');

          if (isInternal) {
            await this.submitInternal({ date: formattedDate, ...fiscalOverrides });
            return;
          }

          const res = await RevisionService.saveWithPayment({
            hasFile: true,
            ...this.state.form,
            user_id: this.props.user?.id,
            date: formattedDate,
            ...fiscalOverrides,
          });
          this.handleSaveWithPaymentResponse(res);
        } catch (e) {
          console.error(e);
          Globals.showError('Lo sentimos, no se pudo procesar el pago');
        }
        break;
      }

      case Constants.PAYMENT_METHODS.STRIPE.toString(): {
        if (!this.state.form.number) {
          Globals.showError('Por favor, ingrese el número de su tarjeta');
          return;
        }
        if (!this.state.form.expiration_month || !this.state.form.expiration_year) {
          Globals.showError('Por favor, ingrese la fecha de vencimiento de su tarjeta');
          return;
        }
        if (!this.state.form.cvv) {
          Globals.showError('Por favor, ingrese el código secreto de su tarjeta');
          return;
        }
        if (
          moment().add(1, 'month').startOf('month') >
          moment(
            `01-${this.state.form.expiration_month}-${this.state.form.expiration_year}`,
            'DD-MM-YYYY',
          )
        ) {
          Globals.showError('Lo sentimos, la fecha de vencimiento no es válida');
          return;
        }
        const params = new URLSearchParams({
          'card[exp_month]': this.state.form.expiration_month,
          'card[exp_year]': this.state.form.expiration_year,
          'card[number]': this.state.form.number,
          'card[cvc]': this.state.form.cvv,
        }).toString();
        try {
          Globals.setLoading();
          // DEV-LT-35 (fix): esta tokenizacion con Stripe es la misma para ambos
          // flujos (interno/externo) -- el backend (BuyUseRevisionDto igual que
          // SaveParams) exige un `token` real generado por Stripe.js/API antes de
          // cobrar; antes, el flujo interno nunca llegaba a este punto.
          const response = await axios.request({
            method: 'POST',
            url: process.env.REACT_APP_STRIPE_URL + 'tokens?' + params,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              Authorization: 'Bearer ' + process.env.REACT_APP_STRIPE_KEY,
            },
          });

          if (isInternal) {
            await this.submitInternal({
              token: response?.data?.id,
              ...fiscalOverrides,
              withoutLoading: true,
            });
            return;
          }

          const res = await RevisionService.saveWithPayment({
            hasFile: true,
            ...this.state.form,
            user_id: this.props.user?.id,
            token: response?.data?.id,
            ...fiscalOverrides,
            withoutLoading: true,
          });
          Globals.quitLoading();
          this.handleSaveWithPaymentResponse(res);
        } catch (e) {
          console.log(e);
          Globals.quitLoading();
          Globals.showError('Lo sentimos, no se pudo procesar el pago');
        }
        break;
      }

      case Constants.PAYMENT_METHODS.SYPAGO.toString(): {
        const {
          sypago_document,
          sypago_document_type,
          sypago_bank_code,
          sypago_phonecode,
          sypago_phone,
          sypago_otp,
        } = this.state.form;
        if (
          !sypago_document ||
          !sypago_document_type ||
          !sypago_bank_code ||
          !sypago_phonecode ||
          !sypago_phone
        ) {
          Globals.showError('Por favor, ingrese todos los datos para continuar');
          return;
        }
        if (sypago_phone.length < 7) {
          Globals.showError('El campo teléfono debe tener 7 dígitos');
          return;
        }
        if (!this.state.otp_send) {
          try {
            await MembershipService.generateOtp({
              user_id: this.props.user?.id,
              ...this.state.form,
              amount: total,
            });
            this.setState({ otp_send: true });
          } catch (e) {
            console.error(e);
            Globals.showError('Lo sentimos, no se pudo solicitar la clave OTP');
          }
          return;
        }
        if (!sypago_otp) {
          Globals.showError('Por favor, ingrese su clave OTP');
          return;
        }
        try {
          const formattedDate =
            this.state.form.date && moment(this.state.form.date, 'DD-MM-YYYY').format('YYYY-MM-DD');

          if (isInternal) {
            await this.submitInternal({ date: formattedDate, ...fiscalOverrides });
            return;
          }

          const res = await RevisionService.saveWithPayment({
            hasFile: true,
            ...this.state.form,
            user_id: this.props.user?.id,
            date: formattedDate,
            ...fiscalOverrides,
          });
          this.handleSaveWithPaymentResponse(res);
        } catch (e) {
          console.error(e);
          Globals.showError('Lo sentimos, no se pudo procesar el pago');
        }
        break;
      }

      default:
        break;
    }
  };

  submitInternal = async (extraPayload: any = {}) => {
    try {
      await RevisionService.buyUse({
        ...this.state.form,
        user_id: this.props.user?.id,
        price: this.state.service_price,
        ...extraPayload,
      });
      await RevisionService.save({
        ...this.state.form,
        user_id: this.props.user?.id,
      });
      Globals.quitLoading();
      Globals.showSuccess('Su documento ha sido solicitado con éxito');
      this.props.onClose(true);
    } catch (e) {
      console.error(e);
      Globals.quitLoading();
      Globals.showError('Lo sentimos, no se pudo procesar el pago');
    }
  };

  submitNoPayment = async () => {
    try {
      await RevisionService.save({
        ...this.state.form,
        user_id: this.props.user?.id,
        withoutError: true,
      });
      this.props.onClose(true);
    } catch (err: any) {
      const data = err?.response?.data;
      const message =
        data?.error?.message ||
        (typeof data?.message === 'string' ? data.message : null) ||
        'Ha ocurrido un error, por favor intente nuevamente';
      Globals.showError(message, () => this.props.onClose(false));
    }
  };

  handleSaveWithPaymentResponse = (res: any) => {
    const data = res?.data ?? res;
    if (!data?.ok) {
      Globals.showError(data?.message || 'Lo sentimos, no se pudo procesar el pago');
      return;
    }
    Globals.showSuccess('Su documento ha sido solicitado con éxito');
    const pdfUrl = data?.facturaPDF?.pdf;
    if (pdfUrl) window.open(pdfUrl, '_blank');
    this.props.onClose(true);
  };

  clipboard = (e: any, text: string) => {
    e.preventDefault();
    navigator.clipboard.writeText(text);
  };

  back = () => {
    const document_types: any = this.state.document_types;
    const phonecodes: any = this.state.phonecodes;
    switch (this.state.step) {
      case STEPS.DOCUMENT:
        this.setState({
          form: {
            ...this.state.form,
            area_id: '',
            document_id: '',
            search: '',
          },
          documents: [],
          step: STEPS.AREA,
        });
        break;
      // Nuevo: desde AREA se puede volver a TYPE -- antes AREA era el primer
      // paso y no tenía a dónde retroceder.
      case STEPS.AREA:
        this.setState({
          form: { ...this.state.form, area_id: '', lawyer_type: '', search: '' },
          areas: [],
          step: STEPS.TYPE,
          visible_fee_notice: false,
          fee_notice_reason: null,
        });
        break;
      case STEPS.ORDER:
        this.setState({ step: STEPS.DOCUMENT });
        break;
      case STEPS.PAYMENT:
        this.setState({
          form: {
            ...this.state.form,
            payment_method_id: '',
            expiration_month: '',
            expiration_year: '',
            number: '',
            cvv: '',
            bank_id: '',
            phone: '',
            date: '',
            reference: '',
            sypago_document_type: document_types.length > 0 ? document_types[0].name : '',
            sypago_phonecode: phonecodes.length > 0 ? phonecodes[0].name : '',
            sypago_bank_code: '',
            sypago_phone: '',
            sypago_document: '',
            sypago_otp: '',
            sypago_name: '',
          },
          otp_send: false,
          step: STEPS.ORDER,
        });
        break;
    }
  };

  render() {
    const { step } = this.state;
    const area: any = this.state.areas.find((i: any) => i.id == this.state.form.area_id);
    const selectedDocument: any = this.state.documents.find(
      (i: any) => i.id == this.state.form.document_id,
    );
    const bank_data: any = this.state.bank_data;
    const { subtotal, iva_total, igtf_total, total } = this.getTotal();
    const isStripe =
      this.state.form.payment_method_id?.toString() === Constants.PAYMENT_METHODS.STRIPE.toString();
    let title = this.state.form.area_id
      ? area?.name
      : step === STEPS.TYPE
        ? 'Tipo de abogado'
        : 'Área de derecho';

    return (
      <div id='modal-create-revision'>
        {(step == STEPS.TYPE || step == STEPS.AREA || step == STEPS.DOCUMENT) && (
          <>
            <div className='row'>
              <div className='col-md-6'>
                {step > STEPS.TYPE && (
                  <button className='btn btn-back' onClick={() => this.back()}>
                    <img src={BackIcon} />
                  </button>
                )}
              </div>
              <div className='col-md-6 text-right'>
                <button className='btn btn-close' onClick={() => this.props.onClose(false)}>
                  <img src={CloseIcon} />
                </button>
              </div>
            </div>
            <h3>{title}</h3>
            {step !== STEPS.TYPE && (
              <div className='container-input'>
                <Input
                  value={this.state.form.search}
                  name='search'
                  placeholder='Nombre'
                  className='input-table'
                  onChange={(e: any) => this.change(e)}
                />
              </div>
            )}
          </>
        )}

        {this.state.visible_fee_notice && (
          <div className='external-fee-modal'>
            <div className='external-fee-modal__icon'>&#9432;</div>
            <div className='external-fee-modal__body'>
              {this.state.fee_notice_reason === 'no_membership' &&
                this.state.form.lawyer_type === 'internal' && (
                  <>
                    <p className='external-fee-modal__title'>No cuenta con una membresía activa</p>
                    <p className='external-fee-modal__text'>
                      Para continuar, puede adquirir una membresía que incluya el servicio de
                      revisión documental, o bien pagar por este uso de forma individual.
                    </p>
                  </>
                )}
              {/* DESACTIVADO temporalmente junto con el fee de plataforma para
                  revisión documental con abogados externos (directorio):
                  fee_notice_reason ya no se asigna a 'no_marketplace', ni a
                  'no_membership' con lawyer_type 'external' (ver selectType).
              {this.state.fee_notice_reason === 'no_membership' &&
                this.state.form.lawyer_type === 'external' && (
                  <>
                    <p className='external-fee-modal__title'>No cuenta con una membresía activa</p>
                    <p className='external-fee-modal__text'>
                      Para continuar con una consulta con abogados del directorio, deberá pagar el
                      fee a la plataforma al momento de elegir abogado, o bien adquirir una
                      membresía que incluya este servicio.
                    </p>
                  </>
                )}
              {this.state.fee_notice_reason === 'no_marketplace' && (
                <>
                  <p className='external-fee-modal__title'>Su membresía no incluye este servicio</p>
                  <p className='external-fee-modal__text'>
                    Su membresía actual no cuenta con el servicio de revisión documental con
                    abogados del directorio. Puede cambiar a una membresía que lo incluya, o bien
                    pagar el fee correspondiente a la plataforma al momento de elegir abogado.
                  </p>
                </>
              )}
              */}
              {this.state.fee_notice_reason === 'no_uses' && (
                <>
                  <p className='external-fee-modal__title'>No cuenta con usos disponibles</p>
                  <p className='external-fee-modal__text'>
                    Puede comprar un uso adicional para continuar.
                  </p>
                </>
              )}
            </div>
          </div>
        )}

        <div className='white-container'>
          {step === STEPS.TYPE && (
            <div style={{ paddingTop: '10px' }}>
              <button className='btn-area' onClick={() => this.selectType('internal')}>
                <img
                  src={ModeratorsIcon}
                  style={{ width: 24, height: 24, marginRight: 10, verticalAlign: 'middle' }}
                />
                Abogado consulta interna
              </button>
              <button className='btn-area' onClick={() => this.selectType('both')}>
                <img
                  src={UserCircleIcon}
                  style={{ width: 24, height: 24, marginRight: 10, verticalAlign: 'middle' }}
                />
                Abogado del directorio
              </button>
            </div>
          )}

          {step == STEPS.AREA && (
            <>
              {this.state.areas
                .filter(
                  (i: any) =>
                    !this.state.form.search ||
                    Globals.clean(i.name).search(Globals.clean(this.state.form.search)) != -1,
                )
                .map((item: any) => (
                  <button
                    className='btn-area'
                    key={item.id}
                    onClick={async () => {
                      await this.loadDocuments(item.id);
                      this.setState({
                        form: {
                          ...this.state.form,
                          area_id: item.id,
                          search: '',
                        },
                        step: STEPS.DOCUMENT,
                      });
                    }}
                  >
                    {item.name}
                  </button>
                ))}
            </>
          )}

          {step == STEPS.DOCUMENT && (
            <>
              <p className='subtitle'>Selecciona el documento que necesita</p>
              {this.state.documents
                .filter(
                  (i: any) =>
                    !this.state.form.search ||
                    Globals.clean(i.name).search(Globals.clean(this.state.form.search)) != -1,
                )
                .map((item: any) => (
                  <button
                    className={`btn-document ${this.state.form.document_id == item.id ? 'active' : ''}`}
                    key={item.id}
                    onClick={() =>
                      this.setState({
                        form: { ...this.state.form, document_id: item.id },
                      })
                    }
                  >
                    <div style={{ flex: 1, display: 'flex', alignItems: 'center' }}>
                      <div
                        className={`check ${this.state.form.document_id == item.id ? 'active' : ''}`}
                      >
                        {this.state.form.document_id == item.id && <img src={CheckWhiteIcon} />}
                      </div>
                      {item.name}
                    </div>
                  </button>
                ))}
              {this.state.form.document_id != '' && (
                <div className='text-center'>
                  <button
                    className='btn btn-submit'
                    onClick={() => {
                      if (this.state.form.lawyer_type === 'both') {
                        this.props.onClose(false, { ...this.state.form });
                        return;
                      }
                      if (this.props.membership_status === Constants.ACCES_STATUS.ACCESS_GRANTED) {
                        this.submitNoPayment();
                        return;
                      }
                      this.setState({ step: STEPS.ORDER });
                    }}
                  >
                    Adquirir
                  </button>
                </div>
              )}
            </>
          )}

          {step == STEPS.ORDER && (
            <div className='payment-content'>
              <button className='btn btn-back' onClick={() => this.back()}>
                <img src={BackIcon} />
              </button>
              <p className='title'>Mi pedido</p>
              <StepsContainer step={step} />
              <div className='container-mode'>
                <h3>{selectedDocument?.name}</h3>
                <div className='container-total'>
                  <div className='row row-total'>
                    <div className='col-6'>
                      <div className='container-circle'>
                        <p>Uso adicional</p>
                      </div>
                    </div>
                    <div className='col-6 text-right'>
                      <p className='bold'>{Globals.formatMiles(this.state.service_price)}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className='fee-notice'>
                <div className='fee-notice__icon'>&#9432;</div>
                <div className='fee-notice__body'>
                  <p className='fee-notice__title'>Uso adicional</p>
                  <p className='fee-notice__text'>
                    Este monto corresponde a un uso adicional del servicio de Revisión Documental
                    con un abogado de consulta interna.
                  </p>
                </div>
              </div>

              <div className='container-total' style={{ paddingBottom: '10px' }}>
                <div className='row row-total'>
                  <div className='col-6'>
                    <p>Sub-total</p>
                  </div>
                  <div className='col-6 text-right'>
                    <p className='bold'>{Globals.formatMiles(subtotal)}</p>
                  </div>
                </div>
                <div className='separator' />
                <div className='row row-total'>
                  <div className='col-6'>
                    <p>Impuesto</p>
                  </div>
                  <div className='col-6 text-right'>
                    <p className='bold'>{Globals.formatMiles(iva_total)}</p>
                  </div>
                </div>
                <div className='total-blue'>
                  <div className='row'>
                    <div className='col-6'>
                      <p className='bold'>Total</p>
                    </div>
                    <div className='col-6 text-right'>
                      <p className='bold'>{Globals.formatMiles(total)}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className='text-center'>
                <button
                  className='btn btn-next'
                  onClick={() => this.setState({ step: STEPS.PAYMENT })}
                >
                  Pagar
                </button>
              </div>
            </div>
          )}

          {step == STEPS.PAYMENT && (
            <div className='payment-content'>
              <button className='btn btn-back' onClick={() => this.back()}>
                <img src={BackIcon} />
              </button>
              <p className='title'>Mi pedido</p>
              <StepsContainer step={step} />

              <div className='container-total' style={{ paddingBottom: '10px' }}>
                <div className='row row-total'>
                  <div className='col-6'>
                    <p>Sub-total</p>
                  </div>
                  <div className='col-6 text-right'>
                    <p className='bold'>{Globals.formatMiles(subtotal)}</p>
                  </div>
                </div>
                <div className='separator' />
                <div className='row row-total'>
                  <div className='col-6'>
                    <p>IVA</p>
                  </div>
                  <div className='col-6 text-right'>
                    <p className='bold'>{Globals.formatMiles(iva_total)}</p>
                  </div>
                </div>
                {isStripe && (
                  <>
                    <div className='separator' />
                    <div className='row row-total'>
                      <div className='col-6'>
                        <p>IGTF</p>
                      </div>
                      <div className='col-6 text-right'>
                        <p className='bold'>{Globals.formatMiles(igtf_total)}</p>
                      </div>
                    </div>
                  </>
                )}
                <div className='total-blue' style={{ marginTop: '10px' }}>
                  <div className='row'>
                    <div className='col-6'>
                      <p className='bold'>Total</p>
                    </div>
                    <div className='col-6 text-right'>
                      <p className='bold'>{Globals.formatMiles(total)}</p>
                    </div>
                  </div>
                </div>
              </div>

              <p className='total'>{Globals.formatMiles(total)}</p>
              <p className='total bs'>
                {Globals.formatMiles(total * this.state.conversion, true, 'Bs.')}
              </p>

              <div className='row row-payment-methods'>
                {this.state.payment_methods.map((item: any) => (
                  <div className='col-md-6' key={item.id}>
                    <button
                      className={`btn btn-payment-method ${item.only_icon ? 'center' : ''} ${item.id == this.state.form.payment_method_id ? 'active' : ''}`}
                      style={{
                        backgroundColor: item.color || Colors.blue_light,
                      }}
                      onClick={() => this.selectPaymentMethod(item.id)}
                    >
                      <img src={Constants.BASE_PUBLIC + item.icon} />
                      {!item.only_icon && <p className='method-name'>{item.name}</p>}
                    </button>
                  </div>
                ))}
              </div>

              {/* Ancla de scroll — el formulario aparece aquí */}
              <div ref={this.formRef}>
                {this.state.form.payment_method_id ==
                  Constants.PAYMENT_METHODS.PAYMENT_MOBILE.toString() && (
                  <div className='container-payment-mobile'>
                    <div className='row'>
                      <div className='col-md-12'>
                        <p className='bank'>
                          {bank_data?.bank?.name} - {bank_data?.bank?.code}
                        </p>
                      </div>
                      <div className='col-md-6'>
                        <p className='label-data'>Teléfono</p>
                      </div>
                      <div className='col-md-6 text-right'>
                        <div className='container-copy'>
                          <p className='bank-data'>
                            {bank_data?.phonecode?.name}
                            {bank_data?.phone}
                          </p>
                          <a
                            href='#'
                            onClick={(e: any) =>
                              this.clipboard(e, bank_data?.phonecode?.name + bank_data?.phone)
                            }
                          >
                            <img src={CopyIcon} />
                          </a>
                        </div>
                      </div>
                      <div className='col-md-6'>
                        <p className='label-data'>Cédula/RIF</p>
                      </div>
                      <div className='col-md-6 text-right'>
                        <div className='container-copy'>
                          <p className='bank-data'>
                            {bank_data?.document_type?.name}
                            {bank_data?.document}
                          </p>
                          <a
                            href='#'
                            onClick={(e: any) =>
                              this.clipboard(
                                e,
                                bank_data?.document_type?.name + bank_data?.document,
                              )
                            }
                          >
                            <img src={CopyIcon} />
                          </a>
                        </div>
                      </div>
                    </div>
                    <p className='subtitle-data'>Indique datos para realizar operación</p>
                    <div className='row'>
                      <div className='col-md-12'>
                        <Select
                          label='Banco'
                          color='white'
                          placeholder='Banco de origen'
                          name='bank_id'
                          onChange={this.change}
                          value={this.state.form.bank_id}
                          options={this.state.banks.map((item: any) => ({
                            value: item.id,
                            label: item.name,
                          }))}
                        />
                      </div>
                      <div className='col-md-6'>
                        <div className='container-select'>
                          <label>Teléfono</label>
                          <div>
                            <Select
                              color='white'
                              name='phonecode_id'
                              onChange={this.change}
                              value={this.state.form.phonecode_id}
                              options={this.state.phonecodes.map((item: any) => ({
                                value: item.id,
                                label: item.name,
                              }))}
                            />
                            <Input
                              maxLength={7}
                              type='number'
                              color='white'
                              value={this.state.form.phone}
                              name='phone'
                              onChange={this.change}
                            />
                          </div>
                        </div>
                      </div>
                      <div className='col-md-6'>
                        <DatePicker
                          label='Fecha'
                          placeholder='Fecha'
                          maxDate={moment().toDate()}
                          onChange={(text: string) =>
                            this.change({
                              target: { value: text, name: 'date' },
                            })
                          }
                          value={this.state.form.date}
                        />
                      </div>
                    </div>
                    <Checkbox
                      label='Declaro que los fondos utilizados son de origen lícito'
                      checked={this.state.form.is_checked}
                      onChange={() =>
                        this.setState({
                          form: {
                            ...this.state.form,
                            is_checked: !this.state.form.is_checked,
                          },
                        })
                      }
                      name='is_checked'
                    />
                    <div className='text-center'>
                      <button className='btn btn-next' onClick={() => this.submit()}>
                        Pagar
                      </button>
                    </div>
                  </div>
                )}

                {this.state.form.payment_method_id ==
                  Constants.PAYMENT_METHODS.STRIPE.toString() && (
                  <div className='container-stripe'>
                    <div className='text-center'>
                      <img src={StripeImage} />
                    </div>
                    <p className='subtitle-data'>Indique datos para realizar operación</p>
                    <div className='row'>
                      <div className='col-md-12'>
                        <Input
                          maxLength={16}
                          type='number'
                          color='white'
                          value={this.state.form.number}
                          name='number'
                          placeholder='Número de tarjeta'
                          onChange={this.change}
                        />
                      </div>
                      <div className='col-md-6'>
                        <Select
                          color='white'
                          placeholder='Mes'
                          name='expiration_month'
                          onChange={this.change}
                          value={this.state.form.expiration_month}
                          options={this.state.months.map((item: any) => ({
                            value: item.value,
                            label: item.name,
                          }))}
                        />
                      </div>
                      <div className='col-md-6'>
                        <Select
                          color='white'
                          placeholder='Año'
                          name='expiration_year'
                          onChange={this.change}
                          value={this.state.form.expiration_year}
                          options={this.state.years.map((item: any) => ({
                            value: item.value,
                            label: item.name,
                          }))}
                        />
                      </div>
                      <div className='col-md-12'>
                        <Input
                          maxLength={4}
                          type='password'
                          color='white'
                          value={this.state.form.cvv}
                          name='cvv'
                          placeholder='Código (CVC)'
                          onChange={this.change}
                        />
                      </div>
                    </div>
                    <Checkbox
                      label='Declaro que los fondos utilizados son de origen lícito'
                      checked={this.state.form.is_checked}
                      onChange={() =>
                        this.setState({
                          form: {
                            ...this.state.form,
                            is_checked: !this.state.form.is_checked,
                          },
                        })
                      }
                      name='is_checked'
                    />
                    <div className='text-center'>
                      <button className='btn btn-next' onClick={() => this.submit()}>
                        Pagar
                      </button>
                    </div>
                  </div>
                )}

                {this.state.form.payment_method_id ==
                  Constants.PAYMENT_METHODS.SYPAGO.toString() && (
                  <div className='container-payment-mobile'>
                    <p className='subtitle-data'>Indique datos para realizar operación</p>
                    <div className='row'>
                      <div className='col-md-12'>
                        <Select
                          color='white'
                          label='Banco'
                          name='sypago_bank_code'
                          onChange={this.change}
                          value={this.state.form.sypago_bank_code}
                          options={this.state.sypago_banks.map((item: any) => ({
                            value: item.code || item.Code,
                            label: item.name || item.Name,
                          }))}
                        />
                      </div>
                      <div className='col-md-6'>
                        <div className='container-select'>
                          <label>Teléfono</label>
                          <div>
                            <Select
                              color='white'
                              name='sypago_phonecode'
                              onChange={this.change}
                              value={this.state.form.sypago_phonecode}
                              options={this.state.phonecodes.map((item: any) => ({
                                value: item.name,
                                label: item.name,
                              }))}
                            />
                            <Input
                              maxLength={7}
                              type='number'
                              color='white'
                              value={this.state.form.sypago_phone}
                              name='sypago_phone'
                              onChange={this.change}
                            />
                          </div>
                        </div>
                      </div>
                      <div className='col-md-6'>
                        <div className='container-select'>
                          <label>Cédula/RIF</label>
                          <div>
                            <Select
                              color='white'
                              name='sypago_document_type'
                              onChange={this.change}
                              value={this.state.form.sypago_document_type}
                              options={this.state.document_types.map((item: any) => ({
                                value: item.name,
                                label: item.name,
                              }))}
                            />
                            <Input
                              maxLength={9}
                              type='number'
                              color='white'
                              value={this.state.form.sypago_document}
                              name='sypago_document'
                              onChange={this.change}
                            />
                          </div>
                        </div>
                      </div>
                      {this.state.otp_send && (
                        <div className='col-md-12'>
                          <p className='otp'>
                            Su banco se comunicará con usted para enviarle la clave OTP. Por favor,
                            ingrese su clave OTP:
                          </p>
                          <Input
                            maxLength={8}
                            type='number'
                            color='white'
                            value={this.state.form.sypago_otp}
                            name='sypago_otp'
                            placeholder='Clave OTP'
                            onChange={(e: any) => this.change(e, undefined, false)}
                          />
                        </div>
                      )}
                    </div>
                    <Checkbox
                      label='Declaro que los fondos utilizados son de origen lícito'
                      checked={this.state.form.is_checked}
                      onChange={() =>
                        this.setState({
                          form: {
                            ...this.state.form,
                            is_checked: !this.state.form.is_checked,
                          },
                        })
                      }
                      name='is_checked'
                    />
                    <div className='text-center'>
                      <button className='btn btn-next' onClick={() => this.submit()}>
                        {this.state.otp_send ? 'Pagar' : 'Continuar'}
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return { user: state.user };
})(ModalCreatePayment);
